import { Component, ElementRef, OnDestroy, effect, inject, viewChild } from '@angular/core';
import { Auth } from '../../services/auth/auth';
import { CLERK_APPEARANCE } from '../../services/auth/clerk-configuration';

@Component({
  selector: 'app-organization-switcher',
  template: `<div #container></div>`,
})
export class OrganizationSwitcher implements OnDestroy {
  private readonly auth = inject(Auth);
  private readonly container = viewChild.required<ElementRef<HTMLDivElement>>('container');
  private mounted = false;

  constructor() {
    effect(() => {
      if (!this.auth.isLoaded()) return;
      const clerk = this.auth.getClerk();
      const el = this.container().nativeElement;
      if (!clerk || this.mounted) return;

      clerk.mountOrganizationSwitcher(el, {
        afterCreateOrganizationUrl: '/',
        afterSelectOrganizationUrl: '/',
        afterLeaveOrganizationUrl: '/',
        appearance: {
          variables: CLERK_APPEARANCE,
          elements: {
            organizationSwitcherTrigger:
              'px-3 py-1.5 rounded-lg bg-surface-dark border border-gray-700 hover:border-accent',
            organizationPreviewMainIdentifier__organizationSwitcherActiveOrganization: {
              color: '#ffffff',
            },
            organizationPreviewSecondaryIdentifier__organizationSwitcherActiveOrganization: {
              color: '#9ca3af',
            },
          },
        },
      });
      this.mounted = true;
    });
  }

  ngOnDestroy(): void {
    if (!this.mounted) return;
    const clerk = this.auth.getClerk();
    const el = this.container().nativeElement;
    if (clerk && el) {
      clerk.unmountOrganizationSwitcher(el);
    }
    this.mounted = false;
  }
}
